import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import { modelSolution } from '../../../../constants/hash-route.constants';
import { appendToUrlPath, skipDuplicates } from '../../../../utils/link.utils';
import { TCHHomeProductDashSeriesItem } from '../../types/productDashboard.types';
import SolutionBadge from './productCard/solutionBadge';
import ProductCard from './productCard';
import AnalyticsVisibleEvent from '../../../@shared/analyticsVisibleEvent';
import { homeProductSelectorLineVisible, homeProductSelectorSeriesClick } from '../../../../constants/analytics.constants';
import { googleLineSeriesClick } from '../../../../utils/analytics';

import './styles.scss';

export type TProductCardSection = {
  cardTitle?: string;
  cardItems?: TCHHomeProductDashSeriesItem[];
  onClick: (cardItemsProps: TCHHomeProductDashSeriesItem, cardIndex: number) => void;
  cardType: string;
  productsItemUrl: string;
  seriesTitleUrl?: string;
  cardTitleForAnalytics?: string;
};

const ProductCardSection: FC<WithTranslation & TProductCardSection> = (props) => {
  const { cardTitle, cardItems, onClick, cardType, productsItemUrl, seriesTitleUrl, cardTitleForAnalytics, t } = props;
  const baseUrl = `${productsItemUrl}/${seriesTitleUrl}`;
  const seriesCardType = cardType === 'series';

  const handlecardItemClick = (cardItemsProps, cardIndex): void => {
    onClick(cardItemsProps, cardIndex);
  };

  return (
    <AnalyticsVisibleEvent event={homeProductSelectorLineVisible} productLine={cardTitleForAnalytics}>
      <section className="product-dashboard-card-section">
        <div className="product-dashboard-card-section__scrollbar">
          {cardTitle && <Text tag="div" field={{ value: cardTitle }} className="heading__title" editable={false} />}
          <div className="product-dashboard-card">
            {cardItems?.map((item, index) => {
              return (
                <article
                 key={item?.id}
                 className="product-dashboard-card__wrapper"
                 onClick={() => googleLineSeriesClick(
                  homeProductSelectorSeriesClick,
                  cardTitleForAnalytics,
                  item?.title,
                  t('cnhi-viewAllModels'),
                  skipDuplicates(appendToUrlPath(baseUrl, item?.titleUrl || ''))
                )}
                >
                  {baseUrl && (
                    <SolutionBadge
                      {...props}
                      data={item}
                      linkUrl={skipDuplicates(appendToUrlPath(baseUrl, (item?.titleUrl || '') + '#' + modelSolution))}
                    />
                  )}
                  {seriesCardType ? (
                    <div onClick={(): void => handlecardItemClick(cardItems, index)} className="product-dashboard-card__wrapper--card">
                      <ProductCard {...props} data={item} onClick={(): void => handlecardItemClick(cardItems, index)} />
                    </div>
                  ) : (
                    <RoutableNotEditableLink
                      href={skipDuplicates(appendToUrlPath(baseUrl, item?.titleUrl || ''))}
                      className="product-dashboard-card__wrapper--card"
                    >
                      <ProductCard
                        {...props}
                        data={item}
                        onClick={(): void => handlecardItemClick(cardItems, index)}
                        linkUrl={skipDuplicates(appendToUrlPath(baseUrl, item?.titleUrl || ''))}
                      />
                    </RoutableNotEditableLink>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default React.memo(withTranslation()(ProductCardSection));
